import {
  TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING,
  TRESPONSE_PROCESS_LISTING,
  TRESPONSE_PROCESS_MAP_LISTING,
} from '@monorepo/types';

export type TProcessMappingState = {
  processListingRes: TRESPONSE_PROCESS_LISTING | null;
  processMapListingRes: TRESPONSE_PROCESS_MAP_LISTING | null;
  processFactoryAssignListingRes: TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING | null;
};

export const TProcessMappingInfoActionType = {
  FetchProcessListing: 'FETCH_PROCESS_LISTING' as const,
  FetchProcessListingSuccess: 'FETCH_PROCESS_LISTING_SUCCESS' as const,
  FetchProcessListingFailure: 'FETCH_PROCESS_LISTING_FAILURE' as const,
  FetchProcessMapListing: 'FETCH_PROCESS_MAP_LISTING' as const,
  FetchProcessMapListingSuccess: 'FETCH_PROCESS_MAP_LISTING_SUCCESS' as const,
  FetchProcessMapListingFailure: 'FETCH_PROCESS_MAP_LISTING_FAILURE' as const,
  FetchProcessFactoryAssignListing: 'FETCH_PROCESS_FACTORY_ASSIGN_LISTING' as const,
  FetchProcessFactoryAssignListingSuccess: 'FETCH_PROCESS_FACTORY_ASSIGN_LISTING_SUCCESS' as const,
  FetchProcessFactoryAssignListingFailure: 'FETCH_PROCESS_FACTORY_ASSIGN_LISTING_FAILURE' as const,
};
